// ISO 3166-1 alpha-2 country codes
// 常用國家列表（可根據需求擴充）
// ⚠️ 修改時請同步更新後端: app/models/order.rb COUNTRY_CODES
export const COUNTRIES = [
  { code: 'TW', name: '台灣', nameEn: 'Taiwan' },
  { code: 'CN', name: '中國', nameEn: 'China' },
  { code: 'HK', name: '香港', nameEn: 'Hong Kong' },
  { code: 'MO', name: '澳門', nameEn: 'Macau' },
  { code: 'JP', name: '日本', nameEn: 'Japan' },
  { code: 'KR', name: '韓國', nameEn: 'South Korea' },
  { code: 'SG', name: '新加坡', nameEn: 'Singapore' },
  { code: 'MY', name: '馬來西亞', nameEn: 'Malaysia' },
  { code: 'TH', name: '泰國', nameEn: 'Thailand' },
  { code: 'VN', name: '越南', nameEn: 'Vietnam' },
  { code: 'PH', name: '菲律賓', nameEn: 'Philippines' },
  { code: 'ID', name: '印尼', nameEn: 'Indonesia' },
  { code: 'US', name: '美國', nameEn: 'United States' },
  { code: 'CA', name: '加拿大', nameEn: 'Canada' },
  { code: 'GB', name: '英國', nameEn: 'United Kingdom' },
  { code: 'AU', name: '澳洲', nameEn: 'Australia' },
  { code: 'NZ', name: '紐西蘭', nameEn: 'New Zealand' },
  { code: 'FR', name: '法國', nameEn: 'France' },
  { code: 'DE', name: '德國', nameEn: 'Germany' },
  { code: 'IT', name: '義大利', nameEn: 'Italy' },
  { code: 'ES', name: '西班牙', nameEn: 'Spain' },
  { code: 'NL', name: '荷蘭', nameEn: 'Netherlands' },
  { code: 'BE', name: '比利時', nameEn: 'Belgium' },
  { code: 'CH', name: '瑞士', nameEn: 'Switzerland' },
  { code: 'AT', name: '奧地利', nameEn: 'Austria' },
  { code: 'SE', name: '瑞典', nameEn: 'Sweden' },
  { code: 'NO', name: '挪威', nameEn: 'Norway' },
  { code: 'DK', name: '丹麥', nameEn: 'Denmark' },
  { code: 'FI', name: '芬蘭', nameEn: 'Finland' },
  { code: 'PL', name: '波蘭', nameEn: 'Poland' },
  { code: 'CZ', name: '捷克', nameEn: 'Czech Republic' },
  { code: 'RU', name: '俄羅斯', nameEn: 'Russia' },
  { code: 'BR', name: '巴西', nameEn: 'Brazil' },
  { code: 'MX', name: '墨西哥', nameEn: 'Mexico' },
  { code: 'AR', name: '阿根廷', nameEn: 'Argentina' },
  { code: 'CL', name: '智利', nameEn: 'Chile' },
  { code: 'IN', name: '印度', nameEn: 'India' },
  { code: 'AE', name: '阿聯酋', nameEn: 'United Arab Emirates' },
  { code: 'SA', name: '沙烏地阿拉伯', nameEn: 'Saudi Arabia' },
  { code: 'IL', name: '以色列', nameEn: 'Israel' },
  { code: 'TR', name: '土耳其', nameEn: 'Turkey' },
  { code: 'ZA', name: '南非', nameEn: 'South Africa' },
  { code: 'EG', name: '埃及', nameEn: 'Egypt' }
];

// 根據語言獲取國家名稱
export const getCountryName = (code, language = 'zh') => {
  const country = COUNTRIES.find(c => c.code === code);
  if (!country) return code;
  return language === 'en' ? country.nameEn : country.name;
};

// 取得國家選項（用於 Select）
export const getCountryOptions = (language = 'zh') => {
  return COUNTRIES.map(country => ({
    value: country.code,
    label: language === 'en'
      ? `${country.nameEn} (${country.code})`
      : `${country.name} (${country.code})`
  }));
};
